import { combineEpics } from "redux-observable";
import "./ComputeCreateEpic.js";
import ComputeServicePrincipalEpic from "../components/ComputeCreateContainer/ComputeServicePrincipalEpic.js";
import ComputeServiceManagedIdentityEpic from "../components/ComputeCreateContainer/ComputeManagedIdentityEpic.js";
import ComputeCreateEpic from "../components/ComputeCreateContainer/ComputeCreateContainer.epic.js";
const rootEpic = combineEpics(ComputeCreateEpic, ComputeServicePrincipalEpic, ComputeServiceManagedIdentityEpic);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
